import { render, staticRenderFns } from "./Button3d.vue?vue&type=template&id=ab05845c&scoped=true&lang=pug"
import script from "./Button3d.vue?vue&type=script&lang=js"
export * from "./Button3d.vue?vue&type=script&lang=js"
import style0 from "./Button3d.vue?vue&type=style&index=0&id=ab05845c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab05845c",
  null
  
)

export default component.exports